<template>
  <div class="category-container">
    <pageTitle>品种信息管理</pageTitle>

    <div class="main">
      <el-button type="primary" plain @click="addVerietyDialog=true">添加品种信息</el-button>
      <el-dialog title="新增品种信息" :visible.sync="addVerietyDialog">
        <el-form :model="addVarietyData" ref="addVarietyData" :rules="addVarietyRules" label-width="200px">
          <el-form-item label="品种名称" prop="variety_name">
            <el-input v-model="addVarietyData.variety_name"></el-input>
          </el-form-item>
          <el-form-item label="审定（登记）编号" prop="check_number">
            <el-input v-model="addVarietyData.check_number"></el-input>
          </el-form-item>
          <el-form-item label="作物品种" prop="crop_variety">
            <el-input v-model="addVarietyData.crop_variety"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addVerietyDialog = false">取 消</el-button>
          <el-button type="primary" @click="addVariety('addVarietyData')">确 定</el-button>
        </div>
      </el-dialog>


      <div class="categoryList">
        <el-table :data="varietyListData" stripe style="width:100%;margin-bottom: 35px;">
          <el-table-column width="300px" prop="variety_name" label="品种名称"></el-table-column>
          <el-table-column width="320px" prop="check_number" label="审定（登记）编号"></el-table-column>
          <el-table-column width="350px" prop="crop_variety" label="作物品种"></el-table-column>
          <el-table-column width="180px" prop="create_time" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" plain
                         @click.native.prevent="editorVarietyItemDataDialog(scope.$index, scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>


      <el-dialog title="编辑品种信息" :visible.sync="editorVarietyDialog">
        <el-form :model="editorVarietyData" ref="editorVarietyData" :rules="addVarietyRules" label-width="200px">
          <el-form-item label="品种名称" prop="variety_name">
            <el-input v-model="editorVarietyData.variety_name"></el-input>
          </el-form-item>
          <el-form-item label="种子生产经营许可证编号" prop="check_number">
            <el-input v-model="editorVarietyData.check_number"></el-input>
          </el-form-item>
          <el-form-item label="品种地址" prop="crop_variety">
            <el-input v-model="editorVarietyData.crop_variety"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editorVarietyDialog = false">取 消</el-button>
          <el-button type="primary" @click="editorVariety('editorVarietyData')">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import pageTitle from "../components/pageTitle";

export default {
  name: "category",
  components: {
    pageTitle
  },
  data() {
    return {
      //添加品种数据
      addVarietyData: {},
      //添加品种数据验证规则
      addVarietyRules: {
        variety_name: [
          {required: true, message: '请输入品种名称', trigger: 'blur'},
        ],
        check_number: [
          {required: true, message: "请输入种子生产经营许可证编号", trigger: "blur"}
        ],
        crop_variety: [
          {required: true, message: "请输入公司地址", trigger: "blur"}
        ],
      },

      //品种列表数据
      varietyListData: null,

      //添加品种数据模态框
      addVerietyDialog: false,

      //编辑品种数据
      editorVarietyData: {},
      //编辑品种数据模态框
      editorVarietyDialog: false
    }
  },
  methods: {
    //获取公司数据
    getVarietyListData() {
      this.axios.post('variety/getVarietyList').then(success => {
        if (success.data.data) {
          for (const item in success.data.data) {
            success.data.data[item].create_time = success.data.data[item].create_time.substring(0, success.data.data[item].create_time.length - 4)
          }
          // success.data.data.create_time = success.data.data.create_time.substring(0, success.data.data.create_time.length - 3)
          this.varietyListData = success.data.data
        }
      })
    },

    //添加品种
    addVariety(varietyData) {
      this.$refs[varietyData].validate((valiResult) => {
        if (valiResult) {
          this.axios.post('variety/addVariety', this.addVarietyData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '添加品种信息成功'
              })
              this.getVarietyListData()
              this.addVerietyDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //编辑品种
    editorVariety(varietyData) {
      this.$refs[varietyData].validate((valiResult) => {
        if (valiResult) {

          console.log('==========')
          console.log(this.editorVarietyData)
          console.log('==========')

          this.axios.post('variety/updateVariety', this.editorVarietyData).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '编辑品种信息成功'
              })
              this.getVarietyListData()
              this.addVerietyDialog = false
              this.editorVarietyDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //打开编辑模态框
    editorVarietyItemDataDialog(index, row) {
      this.editorVarietyDialog = true
      this.editorVarietyData = {
        id: row.id,
        variety_name: row.variety_name,
        check_number: row.check_number,
        crop_variety: row.crop_variety,
      }
    }
  },
  created() {
    this.getVarietyListData()
  }
}
</script>

<style scoped lang="scss">

.category-container {

  .main {
    margin-left: 10px;

    .categoryList {
      margin-top: 30px;

      ul {
        border-radius: 5px;
        overflow: hidden;

        li {
          list-style: none;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #707070;
          background-color: #DCDFE6;

          label {
            float: left;
            margin-left: 20px;
          }

          .el-button {
            float: right;
            margin-top: 5px;
            margin-right: 10px;
          }
        }

        li:hover {
          background-color: #c0c4cc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/variety.vue